import { TextInput, Box } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type SearchPillProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
};

export function SearchPill({ value, onChange, placeholder = 'Search' }: SearchPillProps) {
  const [focused, setFocused] = useState(false);

  return (
    <Box flex={1} mih={0}>
      <TextInput
        w="100%"
        value={value}
        onChange={e => onChange(e.currentTarget.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        leftSection={<IconSearch size={20} />}
        radius="xl"
        size="md"
        fw={FONT_WEIGHTS.medium}
        styles={theme => ({
          root: {},
          wrapper: { height: 48 },
          input: {
            height: 48,
            borderRadius: 9999,
            backgroundColor: theme.white,
            opacity: '90%',
            border: `2px solid ${focused ? theme.colors.brand[6] : theme.colors.gray[2]}`,
            paddingLeft: 42,
            fontSize: theme.fontSizes.md,
          },
          section: {
            color: theme.colors.gray[6],
            width: 44,
            justifyContent: 'center',
          },
        })}
      />
    </Box>
  );
}
